module.exports = __webpack_public_path__ + "img/metro.453f17f8.png";